/**
 * `match_time` (and `matchTime`) from the API is UTC wall-clock digits with no timezone suffix
 * (e.g. "2026-09-15T19:00:00" for a 21:00 Danish kickoff in CEST). `new Date(...)` on a bare
 * string like that is parsed as browser-local per spec, so the raw UTC digits render unconverted
 * instead of shifting forward to the viewer's local time. Appending "Z" fixes the parse.
 */
export const parseMatchTime = (matchTime: string | Date): Date =>
    typeof matchTime === 'string'
        ? new Date(/[Zz]$|[+-]\d{2}:?\d{2}$/.test(matchTime) ? matchTime : `${matchTime}Z`)
        : matchTime;
